import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function LearningSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const pillars = [{
    title: 'Arquitectura Legal',
    items: ['LLC vs Corporation: cuándo usar cada una', 'Proceso completo de registro', 'Selección correcta de Registered Agent', 'Operating Agreement ejecutable', 'Dirección comercial válida']
  }, {
    title: 'Identidad Fiscal',
    items: ['Obtención del EIN paso a paso', 'Cumplimiento fiscal básico', 'Estructura correcta ante el IRS', 'Documentación fiscal necesaria']
  }, {
    title: 'Ingeniería Financiera',
    items: ['Preparación para neobancos (Mercury, Relay, Novo)', 'Preparación para Stripe y pasarelas', 'Requisitos de banca tradicional', 'Estructura del flujo del dinero', 'Errores que causan bloqueos']
  }, {
    title: 'Sustancia y Mantenimiento',
    items: ['Annual Reports: qué son y cómo cumplir', 'Cumplimiento fiscal continuo', 'Contabilidad empresarial básica', 'Protección del velo corporativo', 'Operación empresarial legítima']
  }];
  return <section className="w-full bg-bg-section py-12 md:py-20 px-4" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-140">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-141">
            Contenido estructurado por pilares
          </h2>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-142">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg overflow-hidden" data-id="element-143">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-4 md:py-5 flex items-center justify-between text-left hover:bg-opacity-80 transition-all" aria-expanded={openIndex === index} data-id="element-144">
                <span className="text-lg md:text-xl font-semibold text-text-primary" data-id="element-145">
                  {pillar.title}
                </span>
                <ChevronDownIcon className={`h-5 w-5 md:h-6 md:w-6 text-accent-primary transition-transform ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-146" />
              </button>

              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="px-4 md:px-6 pb-4 md:pb-6" data-id="element-147">
                  <ul className="space-y-2 md:space-y-3 pt-2" data-id="element-148">
                    {pillar.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start" data-id="element-149">
                        <span className="text-accent-primary mr-2 md:mr-3 mt-0.5 md:mt-1" data-id="element-150">
                          •
                        </span>
                        <span className="text-sm md:text-base text-text-secondary" data-id="element-151">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </motion.div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}